import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchCookielessWordpress } from './branches/BranchCookielessWordpress';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
import { BranchConsiderationProfiles } from './branches/BranchConsiderationProfiles';
import { BranchACQ143 } from './branches/BranchACQ143';
import { BranchACQ143CompanySize } from './branches/BranchACQ143CompanySize';
import { BranchACQ145 } from './branches/BranchACQ145';
const DefaultBranches = [BranchQuestionFallback];
const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber];
export const FlowBranches = {
  [Flow.Crm]: [...softwareSignupBranches, BranchConsiderationProfiles, BranchACQ143, BranchACQ143CompanySize, BranchACQ145],
  [Flow.Marketing]: [...softwareSignupBranches, BranchConsiderationProfiles, BranchACQ143, BranchACQ143CompanySize, BranchACQ145],
  [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch, BranchConsiderationProfiles, BranchACQ143, BranchACQ143CompanySize, BranchACQ145],
  [Flow.Service]: [...softwareSignupBranches, BranchConsiderationProfiles, BranchACQ143, BranchACQ143CompanySize, BranchACQ145],
  [Flow.CmsFree]: [BranchCmsBusinessMaturity, ...softwareSignupBranches],
  [Flow.Integrations]: [BranchCookielessWordpress]
};
export const getFlowBranches = () => {
  return FlowBranches[getFlowKey()] || DefaultBranches;
};